<template>
  <v-card>
    <v-card-text>
      <div class="header">
        <div class="text-capitalize">
          {{ title }} record
        </div>
        <div>
          <slot name="sub-title">
            add desc slot "sub-title"
          </slot>
        </div>
      </div>
      <!--  -->
      <section class="mt-3">
        <v-data-table
          :loading="loading"
          :headers="_headers"
          :items="items"
          :items-per-page="10000"
          class="elevation-1"
          hide-default-footer
        >
          <template v-slot:[`item.date_time`]="{ item }">
            <div>
              <span v-if="title == 'orko'">
                {{ item.date_time }}
              </span>
              <span v-else-if="title == 'tenant'">
                {{ item.filling_datetime }}
              </span>
            </div>
          </template>
          <template v-slot:[`item.bus_no`]="{ item }">
            <div>
              <span v-if="title == 'orko'">
                {{ item?.vehicle_tag }}
              </span>
              <span v-else-if="title == 'tenant'">
                {{ item?.bus_no }}
              </span>
            </div>
          </template>
          <template v-slot:[`item.qty`]="{ item }">
            <div>
              <span v-if="title == 'orko'">
                {{ item?.qty }}
              </span>
              <span v-else-if="title == 'tenant'">
                {{ item?.total_diesel }}
              </span>
            </div>
          </template>
        </v-data-table>
      </section>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    title: {
      type: String,
      default() {
        return "orko";
      },
    },
    headers: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("date_time"),
          align: "left",
          sortable: true,
          value: "date_time",
        },
        {
          text: this.$t("bus_no"),
          align: "left",
          sortable: false,
          value: "bus_no",
        },

        {
          text: this.$t("session_id"),
          align: "left",
          sortable: true,
          value: "session_id",
        },
        {
          text: this.$t("qty"),
          align: "left",
          sortable: true,
          value: "qty",
        },
      ];
      // computed headers for showing columns to role based

      return headers.filter((h) => this.headers.includes(h.value));
    },
  },
};
</script>
<style lang="sass" scoped>
.header
    display: flex
    justify-content: space-between
    align-items: center
    height: 3.8rem
    border-bottom: 1px solid lightgray
    div:first-child
        font-weight: 600
</style>
